// src/components/Checklist.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { notificar } from '../utils/notify';
import '../styles/Checklist.css';

const Checklist = () => {
  const [activeTab, setActiveTab] = useState('enviar');
  const [clientes, setClientes] = useState([]);
  const [clientesSelecionados, setClientesSelecionados] = useState([]);
  const [mensagem, setMensagem] = useState('');

  // Ponte para toasts (react-toastify)
  useEffect(() => { notificar(mensagem); }, [mensagem]);

  const [carregando, setCarregando] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [historico, setHistorico] = useState([]);
  const [assuntoPersonalizado, setAssuntoPersonalizado] = useState('Checklist Contábil - {empresa} - {ultimo_mes}');

  // NOVOS ESTADOS PARA RESULTADO DO ENVIO
  const [resultadoEnvio, setResultadoEnvio] = useState(null);
  const [showResultModal, setShowResultModal] = useState(false);

  // Estados para seleção de meses e ANO
  const [mesesSelecionados, setMesesSelecionados] = useState([]);
  const [anoSelecionado, setAnoSelecionado] = useState(2026);
  
  // ESTADOS PARA MÊS/ANO DO TÍTULO (calculados automaticamente, mas editáveis)
  const [mesTitulo, setMesTitulo] = useState('Fevereiro');
  const [anoTitulo, setAnoTitulo] = useState(2026);
  
  // Estados para modal de preview
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [carregandoPreview, setCarregandoPreview] = useState(false);
  const [textoEditavel, setTextoEditavel] = useState('');

  // ESTADOS PARA ENVIO INDIVIDUAL
  const [enviandoIndividual, setEnviandoIndividual] = useState({});
  const [showModalIndividual, setShowModalIndividual] = useState(false);
  const [clienteIndividual, setClienteIndividual] = useState(null);
  const [mesesIndividuais, setMesesIndividuais] = useState([]);
  const [textoIndividual, setTextoIndividual] = useState('');
  const [anoIndividual, setAnoIndividual] = useState(2026);
  
  // ESTADOS PARA MÊS/ANO DO TÍTULO INDIVIDUAL
  const [mesTituloIndividual, setMesTituloIndividual] = useState('Fevereiro');
  const [anoTituloIndividual, setAnoTituloIndividual] = useState(2026);

  // Estados para filtros
  const [filtros, setFiltros] = useState({
    empresa: '',
    operador: '',
    regime: '',
    tipo_entrega: ''
  });

  // Lista de meses
  const mesesDisponiveis = [
    { value: 'Janeiro', label: 'Janeiro' },
    { value: 'Fevereiro', label: 'Fevereiro' },
    { value: 'Março', label: 'Março' },
    { value: 'Abril', label: 'Abril' },
    { value: 'Maio', label: 'Maio' },
    { value: 'Junho', label: 'Junho' },
    { value: 'Julho', label: 'Julho' },
    { value: 'Agosto', label: 'Agosto' },
    { value: 'Setembro', label: 'Setembro' },
    { value: 'Outubro', label: 'Outubro' },
    { value: 'Novembro', label: 'Novembro' },
    { value: 'Dezembro', label: 'Dezembro' }
  ];

  // ORDENA OS MESES NA ORDEM DO CALENDÁRIO (Janeiro → Dezembro)
  const ordenarMeses = (meses) => {
    const ordem = mesesDisponiveis.map(m => m.value);
    return [...meses].sort((a, b) => ordem.indexOf(a) - ordem.indexOf(b));
  };

  // FUNÇÃO PARA CALCULAR O ÚLTIMO MÊS AUTOMATICAMENTE (SIMILAR AO BACKEND)
  const calcularUltimoMes = (meses, ano = 2026) => {
    if (meses.length === 0) return { mes: 'Fevereiro', ano: 2026 };
    
    const ordemMeses = [
      'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
      'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];
    
    const dataAtual = new Date();
    const mesAtual = dataAtual.getMonth(); // 0-11
    const anoAtual = dataAtual.getFullYear();
    
    let meses2026 = [];
    let meses2025 = [];
    
    meses.forEach(mes => {
      const index = ordemMeses.indexOf(mes);
      if (index === -1) return;
      
      // Se estamos em 2026 ou depois
      if (anoAtual >= 2026) {
        // Meses <= mês atual são 2026, outros são 2025
        if (index <= mesAtual) {
          meses2026.push({ mes, index });
        } else {
          meses2025.push({ mes, index });
        }
      } else {
        // Se ainda em 2025, todos são 2025
        meses2025.push({ mes, index });
      }
    });
    
    // Priorizar 2026
    if (meses2026.length > 0) {
      const ultimoMes2026 = meses2026.reduce((prev, current) => 
        current.index > prev.index ? current : prev
      );
      return { mes: ultimoMes2026.mes, ano: 2026 };
    }
    
    // Senão, usar 2025
    if (meses2025.length > 0) {
      const ultimoMes2025 = meses2025.reduce((prev, current) => 
        current.index > prev.index ? current : prev
      );
      return { mes: ultimoMes2025.mes, ano: 2025 };
    }
    
    // Fallback
    return { mes: 'Fevereiro', ano: 2026 };
  };

  // Carregar dados iniciais
  useEffect(() => {
    carregarClientes();
  }, []);

  useEffect(() => {
    if (activeTab === 'historico') {
      carregarHistorico();
    }
  }, [activeTab]);

  // ATUALIZAR AUTOMATICAMENTE O MÊS/ANO DO TÍTULO QUANDO SELECIONAM MESES
  useEffect(() => {
    if (mesesSelecionados.length > 0) {
      const resultado = calcularUltimoMes(mesesSelecionados, anoSelecionado);
      setMesTitulo(resultado.mes);
      setAnoTitulo(resultado.ano);
    }
  }, [mesesSelecionados, anoSelecionado]);

  // ATUALIZAR MÊS/ANO INDIVIDUAL QUANDO MUDA OS MESES INDIVIDUAIS
  useEffect(() => {
    if (mesesIndividuais.length > 0) {
      const resultado = calcularUltimoMes(mesesIndividuais, anoIndividual);
      setMesTituloIndividual(resultado.mes);
      setAnoTituloIndividual(resultado.ano);
    }
  }, [mesesIndividuais, anoIndividual]);

  const carregarClientes = async () => {
    setCarregando(true);
    try {
      const accessToken = localStorage.getItem('access');
      const response = await axios.get(`${process.env.REACT_APP_API_BASE}/api/clientes-checklist/`, {
        headers: { 'Authorization': `Bearer ${accessToken}` }
      });
      setClientes(response.data.clientes || []);
      setMensagem('');
    } catch (error) {
      setMensagem('Erro ao carregar clientes: ' + (error.response?.data?.erro || error.message));
    } finally {
      setCarregando(false);
    }
  };

  const carregarHistorico = async () => {
    try {
      const accessToken = localStorage.getItem('access');
      const response = await axios.get(`${process.env.REACT_APP_API_BASE}/api/historico-checklist/`, {
        headers: { 'Authorization': `Bearer ${accessToken}` }
      });
      setHistorico(response.data.historico || []);
    } catch (error) {
      console.error('Erro ao carregar histórico:', error);
    }
  };

  const handleSelecionarCliente = (numeroDominio) => {
    setClientesSelecionados(prev =>
      prev.includes(numeroDominio)
        ? prev.filter(id => id !== numeroDominio)
        : [...prev, numeroDominio]
    );
  };

  const handleSelecionarMes = (mes) => {
    setMesesSelecionados(prev =>
      prev.includes(mes)
        ? prev.filter(m => m !== mes)
        : ordenarMeses([...prev, mes])
    );
  };

  // FUNÇÃO PARA ABRIR MODAL INDIVIDUAL
  const abrirModalIndividual = (cliente) => {
    setClienteIndividual(cliente);
    // MESES EM ATRASO (a partir da última entrega) JÁ VÊM MARCADOS, EM ORDEM DE CALENDÁRIO
    setMesesIndividuais(ordenarMeses(cliente.meses_atraso || []));
    setTextoIndividual(cliente.texto_email || '');
    setAnoIndividual(2026);
    
    // CALCULAR MÊS DO TÍTULO BASEADO NOS MESES EM ATRASO
    if (cliente.meses_atraso && cliente.meses_atraso.length > 0) {
      const resultado = calcularUltimoMes(cliente.meses_atraso, 2026);
      setMesTituloIndividual(resultado.mes);
      setAnoTituloIndividual(resultado.ano);
    } else {
      setMesTituloIndividual('Fevereiro');
      setAnoTituloIndividual(2026);
    }
    
    setShowModalIndividual(true);
  };

  // FUNÇÃO PARA ENVIO INDIVIDUAL
  const enviarChecklistIndividual = async () => {
    if (!clienteIndividual || mesesIndividuais.length === 0) {
      setMensagem('Selecione pelo menos um mês');
      return;
    }

    const clienteId = clienteIndividual.numero_dominio;
    setEnviandoIndividual(prev => ({ ...prev, [clienteId]: true }));

    try {
      const accessToken = localStorage.getItem('access');
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/enviar-checklist-individual/`,
        {
          numero_dominio: clienteId,
          meses_selecionados: mesesIndividuais,
          texto_personalizado: textoIndividual,
          ano: anoIndividual,
          mes_titulo: mesTituloIndividual,
          ano_titulo: anoTituloIndividual
        },
        { headers: { 'Authorization': `Bearer ${accessToken}` } }
      );

      if (response.data.success) {
        // MOSTRAR RESULTADO EM MODAL
        setResultadoEnvio(response.data);
        setShowResultModal(true);
        setShowModalIndividual(false);
        carregarClientes();
      } else {
        setMensagem(`${response.data.error}`);
      }

    } catch (error) {
      setMensagem('Erro ao enviar email: ' + (error.response?.data?.error || error.message));
    } finally {
      setEnviandoIndividual(prev => ({ ...prev, [clienteId]: false }));
    }
  };

  // FUNÇÃO PARA ALTERNAR MESES INDIVIDUAIS
  const toggleMesIndividual = (mes) => {
    setMesesIndividuais(prev =>
      prev.includes(mes)
        ? prev.filter(m => m !== mes)
        : ordenarMeses([...prev, mes])
    );
  };

  const selecionarTodos = () => {
    const clientesFiltrados = filtrarClientes();
    if (clientesSelecionados.length === clientesFiltrados.length && clientesFiltrados.length > 0) {
      setClientesSelecionados([]);
    } else {
      setClientesSelecionados(clientesFiltrados.map(c => c.numero_dominio));
    }
  };

  const selecionarTodosMeses = () => {
    if (mesesSelecionados.length === mesesDisponiveis.length) {
      setMesesSelecionados([]);
    } else {
      setMesesSelecionados(mesesDisponiveis.map(m => m.value));
    }
  };

  const filtrarClientes = () => {
    return clientes.filter(cliente =>
      Object.entries(filtros).every(([campo, valor]) => {
        if (!valor) return true;
        const valorCliente = cliente[campo]?.toString().toLowerCase() || '';
        return valorCliente.includes(valor.toLowerCase());
      })
    );
  };

  const gerarPreview = async () => {
    if (clientesSelecionados.length === 0) {
      setMensagem('Selecione pelo menos um cliente');
      return;
    }

    if (mesesSelecionados.length === 0) {
      setMensagem('Selecione pelo menos um mês');
      return;
    }

    setCarregandoPreview(true);
    
    try {
      const accessToken = localStorage.getItem('access');
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/gerar-preview-email/`,
        {
          numero_dominio: clientesSelecionados[0],
          assunto: assuntoPersonalizado,
          meses_selecionados: mesesSelecionados,
          texto_personalizado: textoEditavel || null,
          ano: anoSelecionado,
          mes_titulo: mesTitulo,
          ano_titulo: anoTitulo
        },
        { headers: { 'Authorization': `Bearer ${accessToken}` } }
      );

      if (response.data.success) {
        setPreviewData(response.data);
        if (!textoEditavel) {
          setTextoEditavel(response.data.texto_original || '');
        }
        setShowPreviewModal(true);
      } else {
        setMensagem(`${response.data.error || 'Erro ao gerar preview'}`);
      }

    } catch (error) {
      setMensagem('Erro ao gerar preview: ' + (error.response?.data?.error || error.message));
    } finally {
      setCarregandoPreview(false);
    }
  };

  const atualizarPreview = async () => {
    if (!previewData) return;
    
    setCarregandoPreview(true);
    
    try {
      const accessToken = localStorage.getItem('access');
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/gerar-preview-email/`,
        {
          numero_dominio: clientesSelecionados[0],
          assunto: assuntoPersonalizado,
          meses_selecionados: mesesSelecionados,
          texto_personalizado: textoEditavel,
          ano: anoSelecionado,
          mes_titulo: mesTitulo,
          ano_titulo: anoTitulo
        },
        { headers: { 'Authorization': `Bearer ${accessToken}` } }
      );

      if (response.data.success) {
        setPreviewData(response.data);
      }

    } catch (error) {
      console.error('Erro ao atualizar preview:', error);
    } finally {
      setCarregandoPreview(false);
    }
  };

  const enviarEmails = async () => {
    if (clientesSelecionados.length === 0) {
      setMensagem('Selecione pelo menos um cliente');
      return;
    }

    if (!assuntoPersonalizado.trim()) {
      setMensagem('Digite um assunto para o email');
      return;
    }

    if (mesesSelecionados.length === 0) {
      setMensagem('Selecione pelo menos um mês');
      return;
    }

    setEnviando(true);
    setMensagem('Enviando emails... Aguarde...');
    setShowPreviewModal(false);

    try {
      const accessToken = localStorage.getItem('access');
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/enviar-checklist-cliente/`,
        {
          clientes_selecionados: clientesSelecionados,
          assunto: assuntoPersonalizado,
          meses_selecionados: mesesSelecionados,
          texto_personalizado: textoEditavel || null,
          ano: anoSelecionado,
          mes_titulo: mesTitulo,
          ano_titulo: anoTitulo
        },
        { headers: { 'Authorization': `Bearer ${accessToken}` } }
      );

      if (response.data.success) {
        // MOSTRAR RESULTADO EM MODAL
        setResultadoEnvio(response.data);
        setShowResultModal(true);
        setMensagem('');
        
        setClientesSelecionados([]);
        setMesesSelecionados([]);
        setTextoEditavel('');
        setAnoSelecionado(2026);
        setMesTitulo('Fevereiro');
        setAnoTitulo(2026);
        
        carregarClientes();
        if (activeTab === 'historico') {
          carregarHistorico();
        }
      } else {
        setMensagem(`${response.data.error || 'Erro desconhecido'}`);
      }

    } catch (error) {
      setMensagem('Erro ao enviar emails: ' + (error.response?.data?.error || error.message));
    } finally {
      setEnviando(false);
    }
  };

  const clientesFiltrados = filtrarClientes();

  const formatarEmails = (emails) => {
    if (!emails) return '';
    // o cadastro separa por ; ou , — antes só a vírgula era considerada
    const emailsList = emails.split(/[;,]/).map(email => email.trim()).filter(Boolean);
    return emailsList.length > 1 ? 
      `${emailsList[0]} (+${emailsList.length - 1})` : 
      emailsList[0];
  };

  const truncarTexto = (texto, limite = 100) => {
    if (!texto) return '';
    return texto.length > limite ? texto.substring(0, limite) + '...' : texto;
  };

  return (
    <div className="checklist-page">
      <div className="container-xl checklist-container mt-5 shadow p-5 rounded bg-white">
        <div className="header-wrapper d-flex justify-content-between align-items-center mb-4">
          <div className="d-flex align-items-center">
            <i className="fas fa-envelope header-icon me-3"></i>
            <h2 className="titulo-pagina m-0">Envio de Checklist Contábil</h2>
          </div>
          
          {activeTab === 'enviar' && (
            <div className="d-flex align-items-center gap-4">
              <div className="badge-group">
                <small className="text-muted">Clientes: </small>
                <span className="badge bg-primary fs-5">{clientesSelecionados.length}</span>
                <small className="text-muted ms-3">Meses: </small>
                <span className="badge bg-warning text-dark fs-5">{mesesSelecionados.length}</span>
                <small className="text-muted ms-3">Restam: </small>
                <span className="badge bg-secondary fs-5">{mesesDisponiveis.length - mesesSelecionados.length}</span>
                {mesesSelecionados.length > 0 && (
                  <>
                    <small className="text-muted ms-3">Título: </small>
                    <span className="badge bg-info fs-5">{mesTitulo}/{anoTitulo}</span>
                  </>
                )}
              </div>
              
              <button 
                className="btn btn-success btn-lg"
                onClick={enviarEmails}
                disabled={enviando || clientesSelecionados.length === 0 || mesesSelecionados.length === 0}
              >
                {enviando ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Enviando...
                  </>
                ) : (
                  <>
                    <i className="fas fa-paper-plane me-2"></i>
                    Enviar ({clientesSelecionados.length})
                  </>
                )}
              </button>
            </div>
          )}
        </div>

        {/* Tabs de navegação */}
        <ul className="nav nav-tabs mb-4 nav-tabs-large">
          <li className="nav-item">
            <button 
              className={`nav-link ${activeTab === 'enviar' ? 'active' : ''}`}
              onClick={() => setActiveTab('enviar')}
            >
              <i className="fas fa-paper-plane me-2"></i>
              Enviar Checklist
            </button>
          </li>
          <li className="nav-item">
            <button 
              className={`nav-link ${activeTab === 'historico' ? 'active' : ''}`}
              onClick={() => setActiveTab('historico')}
            >
              <i className="fas fa-history me-2"></i>
              Histórico ({historico.length})
            </button>
          </li>
        </ul>

        {/* Mensagens agora são exibidas como toast (react-toastify) */}

        {/* Tab Enviar */}
        {activeTab === 'enviar' && (
          <>
            {/* Configurações do Email */}
            <div className="card mb-4 card-large">
              <div className="card-header bg-light">
                <h5 className="mb-0"><i className="fas fa-cog me-2"></i>Configurações do Email</h5>
              </div>
              <div className="card-body">
                <div className="row g-4">
                  <div className="col-lg-8">
                    <label className="form-label fw-bold">Assunto do Email:</label>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      value={assuntoPersonalizado}
                      onChange={(e) => setAssuntoPersonalizado(e.target.value)}
                      placeholder="Digite o assunto... Use {empresa} e {ultimo_mes} para personalizar"
                    />
                    <small className="text-muted d-block mt-2">
                      Use <code>{'{empresa}'}</code> e <code>{'{ultimo_mes}'}</code> para personalizar automaticamente
                      <br/>
                      <strong>Exemplo:</strong> Checklist Contábil - Empresa Exemplo - {mesTitulo}/{anoTitulo}
                    </small>
                  </div>
                  <div className="col-lg-4 d-flex align-items-end">
                    <div className="alert alert-info mb-0 w-100 py-3">
                      <small>
                        <strong><i className="fas fa-envelope me-1" aria-hidden="true"></i>Remetente:</strong><br/>
                        juliana@comecehub.com.br
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* SEÇÃO DE MÊS/ANO DO TÍTULO + MESES PARA SOLICITAR */}
            <div className="card mb-4 card-large">
              <div className="card-header bg-light">
                <h5 className="mb-0">
                  <i className="fas fa-calendar me-2"></i>
                  Configurar Meses e Título do Email
                </h5>
              </div>
              <div className="card-body">
                {/* SEÇÃO 1: MÊS/ANO DO TÍTULO (CALCULADO AUTOMATICAMENTE, MAS EDITÁVEL) */}
                <div className="alert alert-warning mb-4">
                  <div className="row g-3 align-items-center">
                    <div className="col-12">
                      <h6 className="mb-3">
                        <i className="fas fa-heading me-2"></i>
                        <strong>Mês/Ano que aparecerá no TÍTULO do email</strong>
                        <small className="text-muted d-block mt-2">
                          Atualizado automaticamente baseado nos meses selecionados, mas você pode alterar
                        </small>
                      </h6>
                    </div>
                    <div className="col-lg-5">
                      <label className="form-label fw-bold">Mês do Título:</label>
                      <select 
                        className="form-select form-select-lg" 
                        value={mesTitulo}
                        onChange={(e) => setMesTitulo(e.target.value)}
                      >
                        {mesesDisponiveis.map(mes => (
                          <option key={mes.value} value={mes.value}>{mes.label}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-lg-3">
                      <label className="form-label fw-bold">Ano do Título:</label>
                      <select 
                        className="form-select form-select-lg" 
                        value={anoTitulo}
                        onChange={(e) => setAnoTitulo(parseInt(e.target.value))}
                      >
                        <option value={2026}>2026</option>
                        <option value={2025}>2025</option>
                      </select>
                    </div>
                    <div className="col-lg-4">
                      <div className="alert alert-success mb-0 py-3">
                        <strong><i className="fas fa-envelope me-1" aria-hidden="true"></i>Assunto será:</strong><br/>
                        <small>Checklist - [Empresa] - <strong>{mesTitulo}/{anoTitulo}</strong></small>
                      </div>
                    </div>
                  </div>
                </div>

                <hr/>

                {/* SEÇÃO 2: MESES PARA SOLICITAR */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="mb-0">
                    <i className="fas fa-list me-2"></i>
                    Meses que serão SOLICITADOS no corpo do email
                  </h6>
                  <button 
                    className="btn btn-outline-primary btn-sm"
                    onClick={selecionarTodosMeses}
                  >
                    {mesesSelecionados.length === mesesDisponiveis.length ? 'Desmarcar Todos' : 'Selecionar Todos'}
                  </button>
                </div>
                
                <div className="row g-3">
                  {mesesDisponiveis.map(mes => (
                    <div key={mes.value} className="col-lg-2 col-md-3 col-sm-4 col-6">
                      <div className="form-check form-check-large">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`mes-${mes.value}`}
                          checked={mesesSelecionados.includes(mes.value)}
                          onChange={() => handleSelecionarMes(mes.value)}
                        />
                        <label className="form-check-label" htmlFor={`mes-${mes.value}`}>
                          {mes.label}
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
                
                {mesesSelecionados.length > 0 && (
                  <div className="mt-4">
                    <strong>Meses selecionados para solicitar ({mesesSelecionados.length}):</strong>
                    <span className="badge bg-secondary ms-2">
                      Pode marcar mais {mesesDisponiveis.length - mesesSelecionados.length}
                    </span>
                    <div className="mt-3">
                      {mesesSelecionados.map(mes => (
                        <span key={mes} className="badge bg-primary me-2 mb-2 py-2 px-3">
                          {mes}
                          <button 
                            type="button" 
                            className="btn-close btn-close-white ms-2" 
                            style={{ fontSize: '0.7em' }}
                            onClick={() => handleSelecionarMes(mes)}
                          ></button>
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Filtros e Controles */}
            <div className="card mb-4 card-large">
              <div className="card-header bg-light d-flex justify-content-between align-items-center">
                <h5 className="mb-0"><i className="fas fa-filter me-2"></i>Filtros</h5>
                <div className="d-flex gap-2">
                  <button 
                    className="btn btn-outline-primary btn-sm"
                    onClick={selecionarTodos}
                  >
                    {clientesSelecionados.length === clientesFiltrados.length && clientesFiltrados.length > 0 ? 
                      'Desmarcar Todos' : 'Selecionar Todos'}
                  </button>
                  <button 
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => setFiltros({empresa: '', operador: '', regime: '', tipo_entrega: ''})}
                  >
                    <i className="fas fa-eraser me-1"></i>
                    Limpar Filtros
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-lg-3 col-md-6">
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      placeholder="Filtrar por empresa..."
                      value={filtros.empresa}
                      onChange={(e) => setFiltros(prev => ({...prev, empresa: e.target.value}))}
                    />
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      placeholder="Filtrar por operador..."
                      value={filtros.operador}
                      onChange={(e) => setFiltros(prev => ({...prev, operador: e.target.value}))}
                    />
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <select
                      className="form-select form-select-lg"
                      value={filtros.regime}
                      onChange={(e) => setFiltros(prev => ({...prev, regime: e.target.value}))}
                    >
                      <option value="">Todos os Regimes</option>
                      <option value="LP">Lucro Presumido</option>
                      <option value="SN">Simples Nacional</option>
                      <option value="LR">Lucro Real</option>
                      <option value="MEI">MEI</option>
                    </select>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <select
                      className="form-select form-select-lg"
                      value={filtros.tipo_entrega}
                      onChange={(e) => setFiltros(prev => ({...prev, tipo_entrega: e.target.value}))}
                    >
                      <option value="">Todos os Tipos</option>
                      <option value="Mensal">Mensal</option>
                      <option value="Quarter">Quarter</option>
                      <option value="Semestral">Semestral</option>
                      <option value="Anual">Anual</option>
                    </select>
                  </div>
                </div>
                
                <div className="mt-3 text-center">
                  <small className="text-muted">
                    Exibindo <strong>{clientesFiltrados.length}</strong> de <strong>{clientes.length}</strong> clientes
                  </small>
                </div>
              </div>
            </div>

            {/* Lista de Clientes */}
            <div className="card card-large">
              <div className="card-header bg-light">
                <h5 className="mb-0"><i className="fas fa-users me-2"></i>Clientes Disponíveis</h5>
              </div>
              <div className="card-body p-0">
                {carregando ? (
                  <div className="text-center p-5">
                    <div className="spinner-border"></div>
                    <p className="mt-2">Carregando clientes...</p>
                  </div>
                ) : (
                  <div className="table-responsive-xl">
                    <table className="table table-hover mb-0 table-lg">
                      <thead className="table-light">
                        <tr>
                          <th width="60" className="text-center">
                            <input
                              type="checkbox"
                              checked={clientesSelecionados.length === clientesFiltrados.length && clientesFiltrados.length > 0}
                              onChange={selecionarTodos}
                            />
                          </th>
                          <th>Empresa</th>
                          <th>Email(s)</th>
                          <th>Operador</th>
                          <th>Regime</th>
                          <th>Tipo Entrega</th>
                          <th>Última Entrega</th>
                          <th>Status</th>
                          <th width="140" className="text-center">Ação Rápida</th>
                        </tr>
                      </thead>
                      <tbody>
                        {clientesFiltrados.map((cliente) => (
                          <tr 
                            key={cliente.numero_dominio}
                            className={clientesSelecionados.includes(cliente.numero_dominio) ? 'table-primary' : ''}
                          >
                            <td className="text-center">
                              <input
                                type="checkbox"
                                checked={clientesSelecionados.includes(cliente.numero_dominio)}
                                onChange={() => handleSelecionarCliente(cliente.numero_dominio)}
                              />
                            </td>
                            <td>
                              <strong>{cliente.empresa}</strong>
                              <br/>
                              <small className="text-muted">#{cliente.numero_dominio}</small>
                            </td>
                            <td>
                              <span title={cliente.email}>
                                {formatarEmails(cliente.email)}
                              </span>
                            </td>
                            <td>
                              <span className="badge bg-secondary">{cliente.operador}</span>
                            </td>
                            <td>
                              <span className="badge bg-info text-dark">{cliente.regime}</span>
                            </td>
                            <td>
                              <span className={`badge ${
                                cliente.tipo_entrega === 'Mensal' ? 'bg-success' :
                                cliente.tipo_entrega === 'Quarter' ? 'bg-warning text-dark' :
                                cliente.tipo_entrega === 'Semestral' ? 'bg-info text-dark' :
                                cliente.tipo_entrega === 'Anual' ? 'bg-danger' : 'bg-secondary'
                              }`}>
                                {cliente.tipo_entrega || 'N/A'}
                              </span>
                            </td>
                            <td>
                              {cliente.ultima_entrega || '-'}
                              {cliente.checklist_enviado && (
                                <span 
                                  title="Checklist enviado para esta competência" 
                                  className="ms-3 text-success"
                                >
                                  <i className="fas fa-check-circle"></i>
                                </span>
                              )}
                            </td>                        
                            <td>
                              {cliente.tem_atraso ? (
                                <div>
                                  <span className="badge bg-danger mb-2 d-block">Em Atraso</span>
                                  <small className="text-muted">
                                    {cliente.meses_atraso.slice(0, 2).join(', ')}
                                    {cliente.meses_atraso.length > 2 && ` +${cliente.meses_atraso.length - 2}`}
                                  </small>
                                </div>
                              ) : (
                                <span className="badge bg-success">Em Dia</span>
                              )}
                            </td>
                            <td className="text-center">
                              {cliente.tem_atraso ? (
                                <button 
                                  className="btn btn-sm btn-warning btn-action"
                                  onClick={() => abrirModalIndividual(cliente)}
                                  disabled={enviandoIndividual[cliente.numero_dominio]}
                                  title={`Enviar checklist para ${cliente.meses_atraso.length} mês(es) em atraso`}
                                >
                                  {enviandoIndividual[cliente.numero_dominio] ? (
                                    <span className="spinner-border spinner-border-sm"></span>
                                  ) : (
                                    <>
                                      <i className="fas fa-paper-plane me-1"></i>
                                      <span className="badge bg-dark ms-1">{cliente.meses_atraso.length}</span>
                                    </>
                                  )}
                                </button>
                              ) : (
                                <button 
                                  className="btn btn-sm btn-outline-secondary btn-action"
                                  onClick={() => abrirModalIndividual(cliente)}
                                  title="Enviar checklist personalizado"
                                >
                                  <i className="fas fa-envelope me-1"></i>
                                  Enviar
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                
                {!carregando && clientesFiltrados.length === 0 && (
                  <div className="text-center p-5">
                    <i className="fas fa-search fa-3x text-muted mb-3"></i>
                    <p className="text-muted">
                      {clientes.length === 0 ? 
                        'Nenhum cliente com dados de checklist encontrado.' : 
                        'Nenhum cliente corresponde aos filtros aplicados.'}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </>
        )}

        {/* Tab Histórico */}
        {activeTab === 'historico' && (
          <div className="card card-large">
            <div className="card-header bg-light d-flex justify-content-between align-items-center">
              <h5 className="mb-0"><i className="fas fa-history me-2"></i>Histórico de Emails Enviados</h5>
              <button 
                className="btn btn-outline-secondary btn-sm"
                onClick={carregarHistorico}
              >
                <i className="fas fa-sync-alt me-2"></i>
                Atualizar
              </button>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive-xl">
                <table className="table table-hover mb-0 table-lg">
                  <thead className="table-light">
                    <tr>
                      <th>Data/Hora</th>
                      <th>Empresa</th>
                      <th>Emails Enviados</th>
                      <th>Assunto</th>
                    </tr>
                  </thead>
                  <tbody>
                    {historico.map((item, index) => (
                      <tr key={index}>
                        <td>{item.data_envio}</td>
                        <td>
                          <strong>{item.empresa}</strong>
                          <br/>
                          <small className="text-muted">#{item.numero_dominio}</small>
                        </td>
                        <td>
                          <small>{item.emails_enviados}</small>
                        </td>
                        <td>{item.assunto}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {historico.length === 0 && (
                <div className="text-center p-5">
                  <i className="fas fa-inbox fa-3x text-muted mb-3"></i>
                  <p className="text-muted">Nenhum email foi enviado ainda.</p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* MODAL DE RESULTADO DO ENVIO */}
      {showResultModal && resultadoEnvio && (
        <div className="modal fade show" style={{ display: 'block' }} aria-modal="true">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
                <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}>
                  <i className="fas fa-check-circle me-2"></i>
                  Resultado do Envio
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowResultModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                
                {/* RESUMO */}
                <div className="row mb-4">
                  <div className="col-6">
                    <div className="card bg-success text-white">
                      <div className="card-body text-center">
                        <h2 className="display-4 mb-0">{resultadoEnvio.total_enviados}</h2>
                        <p className="mb-0"><i className="fas fa-check-circle me-1" aria-hidden="true"></i>Enviados com Sucesso</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="card bg-danger text-white">
                      <div className="card-body text-center">
                        <h2 className="display-4 mb-0">{resultadoEnvio.total_erros}</h2>
                        <p className="mb-0"><i className="fas fa-times-circle me-1" aria-hidden="true"></i>Erros</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* EMAILS ENVIADOS */}
                {resultadoEnvio.emails_enviados && resultadoEnvio.emails_enviados.length > 0 && (
                  <div className="mb-4">
                    <h6 className="text-success">
                      <i className="fas fa-check-circle me-2"></i>
                      Emails Enviados com Sucesso:
                    </h6>
                    <div className="table-responsive">
                      <table className="table table-sm table-bordered">
                        <thead className="table-light">
                          <tr>
                            <th>Empresa</th>
                            <th>Email(s)</th>
                            <th>Reply-To</th>
                          </tr>
                        </thead>
                        <tbody>
                          {resultadoEnvio.emails_enviados.map((item, index) => (
                            <tr key={index}>
                              <td>
                                <strong>{item.empresa}</strong>
                                <br/>
                                <small className="text-muted">#{item.numero_dominio}</small>
                              </td>
                              <td>
                                <small>{item.emails.join(', ')}</small>
                              </td>
                              <td>
                                <small>{item.reply_to}</small>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {/* ERROS */}
                {resultadoEnvio.emails_erro && resultadoEnvio.emails_erro.length > 0 && (
                  <div className="mb-3">
                    <h6 className="text-danger">
                      <i className="fas fa-exclamation-triangle me-2"></i>
                      Erros Encontrados:
                    </h6>
                    <div className="table-responsive">
                      <table className="table table-sm table-bordered">
                        <thead className="table-light">
                          <tr>
                            <th>Empresa / Domínio</th>
                            <th>Erro</th>
                          </tr>
                        </thead>
                        <tbody>
                          {resultadoEnvio.emails_erro.map((item, index) => (
                            <tr key={index}>
                              <td>
                                {item.empresa && <strong>{item.empresa}</strong>}
                                {!item.empresa && <span>#{item.numero_dominio}</span>}
                              </td>
                              <td>
                                <span className="text-danger">{item.erro}</span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-primary btn-lg" 
                  onClick={() => setShowResultModal(false)}
                >
                  <i className="fas fa-check me-2"></i>
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showResultModal && <div className="modal-backdrop fade show"></div>}

      {/* MODAL PARA ENVIO INDIVIDUAL */}
      {showModalIndividual && clienteIndividual && (
        <div className="modal fade show" style={{ display: 'block' }} aria-modal="true">
          <div className="modal-dialog modal-xl modal-dialog-large">
            <div className="modal-content">
              <div className="modal-header bg-light">
                <h5 className="modal-title mb-0 fw-bold">
                  <i className="fas fa-paper-plane me-2 text-primary"></i>
                  Enviar Checklist - {clienteIndividual.empresa}
                </h5>
                <button type="button" className="btn-close" onClick={() => setShowModalIndividual(false)}></button>
              </div>
              <div className="modal-body">
                <div className="row mb-4 g-3">
                  <div className="col-lg-6">
                    <div className="alert alert-info py-3 mb-0">
                      <strong><i className="fas fa-envelope me-1" aria-hidden="true"></i>Destinatário:</strong><br/>
                      {(clienteIndividual.destinatarios || (clienteIndividual.email || '').split(/[;,]/).map(e => e.trim()).filter(Boolean)).map((e) => {
                        const socio = (clienteIndividual.email_socio || '').toLowerCase().includes(e.toLowerCase());
                        return (
                          <span key={e}
                            className={`badge me-1 mb-1 fw-normal ${socio ? 'bg-primary' : 'bg-light text-dark border'}`}
                            title={socio ? 'E-mail do sócio (cliente)' : 'E-mail adicional (cópia)'}>
                            {socio && <i className="fas fa-user-tie me-1" aria-hidden="true"></i>}{e}
                          </span>
                        );
                      })}
                      {clienteIndividual.sem_email_socio && (
                        <div className="text-danger small mt-1">
                          <i className="fas fa-triangle-exclamation me-1" aria-hidden="true"></i>
                          Sem e-mail do sócio no cadastro — vai só para os adicionais.
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="alert alert-secondary py-3 mb-0">
                      <strong><i className="fas fa-calendar-alt me-1" aria-hidden="true"></i>Última entrega:</strong> {clienteIndividual.ultima_entrega}<br/>
                      <strong><i className="fas fa-user me-1" aria-hidden="true"></i>Responsável:</strong> {clienteIndividual.operador}
                    </div>
                  </div>
                </div>

                {/* MÊS/ANO DO TÍTULO NO MODAL INDIVIDUAL */}
                <div className="card mb-3 card-large">
                  <div className="card-header bg-light">
                    <h6 className="mb-0">
                      <i className="fas fa-heading me-2"></i>
                      Mês/Ano do Título do Email
                      <small className="text-muted d-block mt-2">
                        Calculado automaticamente, mas você pode alterar
                      </small>
                    </h6>
                  </div>
                  <div className="card-body">
                    <div className="row g-3 align-items-center">
                      <div className="col-lg-4">
                        <label className="form-label fw-bold">Mês do Título:</label>
                        <select 
                          className="form-select form-select-lg" 
                          value={mesTituloIndividual}
                          onChange={(e) => setMesTituloIndividual(e.target.value)}
                        >
                          {mesesDisponiveis.map(mes => (
                            <option key={mes.value} value={mes.value}>{mes.label}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label fw-bold">Ano do Título:</label>
                        <select 
                          className="form-select form-select-lg" 
                          value={anoTituloIndividual}
                          onChange={(e) => setAnoTituloIndividual(parseInt(e.target.value))}
                        >
                          <option value={2026}>2026</option>
                          <option value={2025}>2025</option>
                        </select>
                      </div>
                      <div className="col-lg-5">
                        <div className="alert alert-success mb-0">
                          <strong><i className="fas fa-envelope me-1" aria-hidden="true"></i>Assunto será:</strong><br/>
                          <small>
                            Checklist Contábil - {clienteIndividual.empresa} - <strong>{mesTituloIndividual}/{anoTituloIndividual}</strong>
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Meses para Solicitar */}
                <div className="card mb-3 card-large">
                  <div className="card-header bg-light d-flex justify-content-between align-items-center">
                    <h6 className="mb-0">
                      <i className="fas fa-calendar me-2"></i>
                      Meses para Solicitar
                      {clienteIndividual.tem_atraso && (
                        <span className="badge bg-danger ms-2">
                          {clienteIndividual.meses_atraso.length} em atraso
                        </span>
                      )}
                    </h6>
                  </div>
                  <div className="card-body">
                    <div className="row g-3">
                      {mesesDisponiveis.map(mes => (
                        <div key={mes.value} className="col-lg-4 col-md-6">
                          <div className={`form-check form-check-large ${
                            clienteIndividual.meses_atraso?.includes(mes.value) ? 'border border-danger bg-light' : ''
                          }`} style={{ padding: '12px', borderRadius: '6px' }}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`mes-ind-${mes.value}`}
                              checked={mesesIndividuais.includes(mes.value)}
                              onChange={() => toggleMesIndividual(mes.value)}
                            />
                            <label className="form-check-label" htmlFor={`mes-ind-${mes.value}`}>
                              {mes.label}
                              {clienteIndividual.meses_atraso?.includes(mes.value) && (
                                <span className="badge bg-danger ms-2" style={{ fontSize: '0.7em' }}>
                                  Atraso
                                </span>
                              )}
                            </label>
                          </div>
                        </div>
                      ))}
                    </div>
                    
                    {mesesIndividuais.length > 0 && (
                      <div className="mt-4">
                        <strong>Selecionados ({mesesIndividuais.length}):</strong>
                        <span className="badge bg-secondary ms-2">
                          Pode marcar mais {mesesDisponiveis.length - mesesIndividuais.length}
                        </span>
                        <div className="mt-3">
                          {mesesIndividuais.map(mes => (
                            <span key={mes} className="badge bg-primary me-2 mb-2 py-2 px-3">
                              {mes}
                              <button 
                                type="button" 
                                className="btn-close btn-close-white ms-2" 
                                style={{ fontSize: '0.7em' }}
                                onClick={() => toggleMesIndividual(mes)}
                              ></button>
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Editor de Texto Individual */}
                <div className="card card-large">
                  <div className="card-header bg-light">
                    <h6 className="mb-0">
                      <i className="fas fa-edit me-2"></i>
                      Documentos Necessários
                    </h6>
                  </div>
                  <div className="card-body">
                    <textarea
                      className="form-control form-control-lg"
                      rows="8"
                      value={textoIndividual}
                      onChange={(e) => setTextoIndividual(e.target.value)}
                      placeholder="Digite os documentos necessários..."
                    />
                    <small className="text-muted mt-2 d-block">
                      <strong>Dica:</strong> Use separadores como <code>;</code> para criar listas automáticas
                    </small>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary btn-lg" onClick={() => setShowModalIndividual(false)}>
                  <i className="fas fa-times me-2"></i>
                  Cancelar
                </button>
                <button 
                  type="button" 
                  className="btn btn-success btn-lg" 
                  onClick={enviarChecklistIndividual}
                  disabled={mesesIndividuais.length === 0 || !textoIndividual.trim()}
                >
                  <i className="fas fa-paper-plane me-2"></i>
                  Enviar ({mesesIndividuais.length} meses - {mesTituloIndividual}/{anoTituloIndividual})
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showModalIndividual && <div className="modal-backdrop fade show"></div>}

      {/* Modal de Preview */}
      {showPreviewModal && previewData && (
        <div className="modal fade show" style={{ display: 'block' }} aria-modal="true">
          <div className="modal-dialog modal-fullscreen modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header bg-light">
                <h5 className="modal-title mb-0 fw-bold">
                  <i className="fas fa-eye me-2"></i>
                  Preview do Email
                </h5>
                <button type="button" className="btn-close" onClick={() => setShowPreviewModal(false)}></button>
              </div>
              <div className="modal-body">
                {/* Para quem vai, de verdade: o sócio (cliente) e os adicionais em cópia.
                    Antes aqui aparecia só o nome da empresa, e ninguém via que o
                    e-mail do cliente estava fora da lista. */}
                <div className="row mb-3 g-3">
                  <div className="col-lg-7">
                    <strong><i className="fas fa-envelope me-1" aria-hidden="true"></i>Para:</strong>{' '}
                    <small>{previewData.empresa}</small>
                    <div className="mt-1">
                      {(previewData.destinatarios || []).length === 0 && (
                        <span className="badge bg-danger">nenhum destinatário no cadastro</span>
                      )}
                      {(previewData.destinatarios || []).map((e) => {
                        const socio = (previewData.email_socio || '').toLowerCase().includes(e.toLowerCase());
                        return (
                          <span key={e}
                            className={`badge me-1 mb-1 fw-normal ${socio ? 'bg-primary' : 'bg-light text-dark border'}`}
                            title={socio ? 'E-mail do sócio (cliente)' : 'E-mail adicional (cópia)'}>
                            {socio && <i className="fas fa-user-tie me-1" aria-hidden="true"></i>}{e}
                          </span>
                        );
                      })}
                    </div>
                    {previewData.sem_email_socio && (
                      <div className="alert alert-warning py-1 px-2 mt-2 mb-0 small">
                        <i className="fas fa-triangle-exclamation me-1" aria-hidden="true"></i>
                        Este cliente <strong>não tem e-mail do sócio</strong> no cadastro — o checklist
                        vai só para os e-mails adicionais. Cadastre o e-mail do sócio em Contabilidade → Detalhes.
                      </div>
                    )}
                    {previewData.reply_to && (
                      <div className="text-muted small mt-1">Respostas vão para: {previewData.reply_to}</div>
                    )}
                  </div>
                  <div className="col-lg-5">
                    <strong>Assunto:</strong> <small>{previewData.assunto}</small>
                  </div>
                </div>
                
                <div className="row mb-3">
                  <div className="col-12">
                    <div className="card card-large">
                      <div className="card-header bg-light d-flex justify-content-between align-items-center">
                        <h6 className="mb-0">
                          <i className="fas fa-edit me-2"></i>
                          Editar Documentos Necessários
                        </h6>
                        <button 
                          className="btn btn-sm btn-outline-primary"
                          onClick={atualizarPreview}
                          disabled={carregandoPreview}
                        >
                          {carregandoPreview ? (
                            <span className="spinner-border spinner-border-sm"></span>
                          ) : (
                            <>
                              <i className="fas fa-sync me-1"></i>
                              Atualizar Preview
                            </>
                          )}
                        </button>
                      </div>
                      <div className="card-body">
                        <textarea
                          className="form-control form-control-lg"
                          rows="8"
                          value={textoEditavel}
                          onChange={(e) => setTextoEditavel(e.target.value)}
                          placeholder="Digite os documentos necessários..."
                        />
                        <small className="text-muted mt-2 d-block">
                          <strong>Dica:</strong> Use separadores como <code>;</code> para criar listas automáticas
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="border rounded p-4" style={{ minHeight: '400px' }}>
                  <div dangerouslySetInnerHTML={{ __html: previewData.preview_html }} />
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary btn-lg" onClick={() => setShowPreviewModal(false)}>
                  <i className="fas fa-times me-2"></i>
                  Cancelar
                </button>
                <button type="button" className="btn btn-success btn-lg" onClick={enviarEmails}>
                  <i className="fas fa-paper-plane me-2"></i>
                  Confirmar e Enviar ({clientesSelecionados.length})
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showPreviewModal && <div className="modal-backdrop fade show"></div>}
    </div>
  );
};

export default Checklist;